'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('./constants');

var _onArrowLeft = require('./onArrowLeft');

var _onArrowLeft2 = _interopRequireDefault(_onArrowLeft);

var _onArrowRight = require('./onArrowRight');

var _onArrowRight2 = _interopRequireDefault(_onArrowRight);

var _onBackspace = require('./onBackspace');

var _onBackspace2 = _interopRequireDefault(_onBackspace);

var _onDelete = require('./onDelete');

var _onDelete2 = _interopRequireDefault(_onDelete);

var _utils = require('./utils');

var _slate = require('slate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var defaults = {
  allowedTypes: null,
  bannedTypes: [],
  hasStickyBoundaries: true,
  canBeEmpty: true,
  stickOnDelete: true

  /**
   * Cross Boundaries on Left Arrow, or Right arrow
   * when on the Start or End of an inline boundary
   * can delete all the text inside and still type to add more
   *
   * @param {Object} options
   *   @property {Array} allowedTypes (optional)
   *   @property {Array} bannedTypes (optional)
   *   @property {Boolean} hasStickyBoundaries (optional)
   *   @property {Boolean} canBeEmpty (optional)
   *   @property {Boolean} stickOnDelete (optional)
   * @return {Object} plugin
   */

};function StickyInlines(opts) {
  var state = {
    sticky: null
  };

  opts = Object.assign({}, defaults, opts);
  var _opts = opts,
      allowedTypes = _opts.allowedTypes,
      bannedTypes = _opts.bannedTypes,
      hasStickyBoundaries = _opts.hasStickyBoundaries,
      canBeEmpty = _opts.canBeEmpty;


  if (allowedTypes && !Array.isArray(allowedTypes)) {
    console.warn('slate-sticky-inline: allowedTypes must be an Array of Strings');
  }
  if (!Array.isArray(bannedTypes)) {
    console.warn('slate-sticky-inlines: bannedTypes must be an Array of Strings');
  }

  /**
   * Keydown entry point.
   *
   * @param {Event} event
   * @param {Editor} editor
   * @param {function} next
   * @return {Editor}
   */

  function onKeyDown(event, editor, next) {
    // We are working inside a specific inline, and they specifically said they don't want it to be sticky.
    if (editor.value.focusInline && (0, _utils.isInlineBanned)(editor, editor.value.focusInline, opts)) return next();

    // They are moving the caret around, let's see if we need to interfere.
    switch (event.which) {
      case _constants.ARROW_LEFT:
        return (0, _onArrowLeft2.default)(event, editor, next, opts, state);
      case _constants.ARROW_RIGHT:
        return (0, _onArrowRight2.default)(event, editor, next, opts, state);
      case _constants.BACKSPACE:
        return (0, _onBackspace2.default)(event, editor, next, opts);
      case _constants.DELETE:
        return (0, _onDelete2.default)(event, editor, next, opts);
      default:
        return next();
    }
  }

  /**
   * Change entry point.  Used right now to clean up non-focused empty inline artifacts
   *
   * @param {Editor} editor
   * @return {Editor}
   */

  function onChange(editor, next) {
    if (!canBeEmpty) return next();

    var _editor$value = editor.value,
        document = _editor$value.document,
        selection = _editor$value.selection;


    var toRemove = document.getInlines().reduce(function (failures, inline) {
      var hasFocus = selection.isFocused && (selection.anchor.isInNode(inline) || selection.focus.isInNode(inline));
      var onlyHasZeroWidthSpace = inline.text === _constants.ZERO_WIDTH_SPACE;

      if ((0, _utils.isInlineBanned)(editor, inline, opts)) return failures;
      return !hasFocus && onlyHasZeroWidthSpace ? [inline].concat(_toConsumableArray(failures)) : failures;
    }, []);

    if (!toRemove.length) return next();

    toRemove.forEach(function (failure) {
      return editor = editor.removeNodeByKey(failure.key);
    });
    return true;
  }

  /**
   * Override getInsertPoint to allow selections on sticky node boundaries.
   *
   * @param {Editor} editor
   * @param {Point} point
   * @param {Node} node
   * @return {Point}
   */

  function getInsertPoint(editor, point, node) {
    var sticky = state.sticky;

    var resolvedPoint = point.resolveToTextNode(node);
    if (resolvedPoint.path == null) return;

    var inline = node.getClosestInline(resolvedPoint.path);

    // If you're in a sticky inline, and you don't have a preference
    // for where to go, let the browser decide. This fixes some
    // problems with new or empty inlines -- otherwise, there would be
    // no way to place the cursor inside of them, as the selection
    // gets resolved to the next text node!
    if (!sticky && !(0, _utils.isInlineBanned)(editor, inline, opts)) {
      return resolvedPoint;
    }

    // Otherwise, if you don't have a preference, do the default.
    if (!sticky) return;

    var resolvedNode = node.getDescendant(resolvedPoint.path);
    var atStartOfNode = resolvedPoint.offset === 0;
    var atEndOfNode = resolvedPoint.offset === resolvedNode.text.length;

    // Handle positions inside a sticky inline at the start or end.
    if (!(0, _utils.isInlineBanned)(editor, inline, opts)) {
      if (atStartOfNode && inline.getFirstText() === resolvedNode) {
        return (0, _utils.resolvePointAtStartOfNode)(resolvedPoint, node, sticky);
      } else if (atEndOfNode && inline.getLastText() === resolvedNode) {
        return (0, _utils.resolvePointAtEndOfNode)(resolvedPoint, node, sticky);
      }
    }

    // Handle positions at the start of a node after a sticky inline.
    if (atStartOfNode) {
      var previousNode = node.getPreviousSibling(resolvedPoint.path);

      if (!(0, _utils.isInlineBanned)(editor, previousNode, opts)) {
        return (0, _utils.resolvePointAtStartOfNode)(resolvedPoint, node, sticky);
      }
    }

    // Handle positions at the end of a node before a sticky inline.
    if (atEndOfNode) {
      var nextNode = node.getNextSibling(resolvedPoint.path);

      if (!(0, _utils.isInlineBanned)(editor, nextNode, opts)) {
        return (0, _utils.resolvePointAtEndOfNode)(resolvedPoint, node, sticky);
      }
    }

    // We aren't at a sticky boundary, so reset the preference.
    state.sticky = null;
    return;
  }

  /**
   * Return the plugin.
   *
   * @type {Object}
   */

  return {
    onKeyDown: onKeyDown,
    onChange: onChange,
    queries: {
      getInsertPoint: getInsertPoint
    }
  };
}

/**
 * Export.
 *
 * @type {Function}
 */

exports.default = StickyInlines;